export interface Category {
  name: string;
  url: string;
  image: string;
}

export const categories: Category[] = [
  {
    name: "Shoes",
    url: "https://kaspreadsheet.com/category-911-Shoes.html",
    image:
      "https://readdy.ai/api/search-image?query=A%20single%20red%20and%20white%20leather%20high-top%20sneaker%20standing%20upright%20on%20a%20soft%20light%20gray%20studio%20background%20with%20crisp%20natural%20window%20light%20and%20a%20clean%20shadow%2C%20minimalist%20streetwear%20e-commerce%20product%20photography%2C%20editorial%20aesthetic%20with%20cool%20neutral%20tones&width=800&height=600&seq=cat-01&orientation=landscape&nocache=true",
  },
  {
    name: "Hoodies/Sweaters",
    url: "https://kaspreadsheet.com/search-912/name/Hoodies-Sweaters.html",
    image:
      "https://readdy.ai/api/search-image?query=A%20folded%20sage%20green%20hoodie%20sweater%20neatly%20stacked%20on%20a%20warm%20beige%20linen%20surface%20with%20soft%20morning%20light%20and%20gentle%20shadows%2C%20minimalist%20apparel%20product%20photography%2C%20cozy%20editorial%20aesthetic&width=800&height=600&seq=cat-02&orientation=landscape&nocache=true",
  },
  {
    name: "T-Shirts",
    url: "https://kaspreadsheet.com/search-913/name/T-Shirts.html",
    image:
      "https://readdy.ai/api/search-image?query=A%20plain%20black%20cotton%20t-shirt%20neatly%20folded%20on%20a%20soft%20sand-toned%20studio%20background%20with%20bright%20natural%20lighting%20and%20a%20subtle%20shadow%2C%20minimalist%20e-commerce%20apparel%20product%20photography%2C%20clean%20modern%20editorial%20aesthetic&width=800&height=600&seq=cat-03&orientation=landscape&nocache=true",
  },
  {
    name: "Jackets",
    url: "https://kaspreadsheet.com/search-914/name/Jackets.html",
    image:
      "https://readdy.ai/api/search-image?query=An%20olive%20green%20utility%20jacket%20hanging%20on%20a%20wooden%20hanger%20against%20a%20warm%20taupe%20wall%20with%20soft%20directional%20lighting%20and%20gentle%20shadows%2C%20minimalist%20fashion%20product%20photography%2C%20editorial%20aesthetic&width=800&height=600&seq=cat-04&orientation=landscape&nocache=true",
  },
  {
    name: "Pants/Shorts",
    url: "https://kaspreadsheet.com/search-915/name/Pants-Shorts.html",
    image:
      "https://readdy.ai/api/search-image?query=A%20pair%20of%20light%20blue%20denim%20jeans%20folded%20flat%20on%20a%20warm%20cream%20studio%20surface%20with%20soft%20natural%20lighting%20and%20a%20clean%20shadow%2C%20minimalist%20denim%20product%20photography%2C%20editorial%20aesthetic&width=800&height=600&seq=cat-05&orientation=landscape&nocache=true",
  },
  {
    name: "Headwear",
    url: "https://kaspreadsheet.com/search-916/name/Headwear.html",
    image:
      "https://readdy.ai/api/search-image?query=A%20camel%20brown%20baseball%20cap%20displayed%20on%20a%20soft%20blush%20pink%20background%20with%20gentle%20natural%20lighting%20and%20a%20subtle%20shadow%2C%20minimalist%20headwear%20product%20photography%2C%20clean%20editorial%20aesthetic&width=800&height=600&seq=cat-06&orientation=landscape&nocache=true",
  },
  {
    name: "Sets",
    url: "https://kaspreadsheet.com/search-917/name/Sets.html",
    image:
      "https://readdy.ai/api/search-image?query=A%20coordinated%20matching%20outfit%20set%20of%20a%20terracotta%20top%20and%20cream%20trousers%20laid%20flat%20on%20a%20soft%20beige%20background%20with%20warm%20natural%20lighting%20and%20gentle%20shadows%2C%20minimalist%20fashion%20flat%20lay%20product%20photography%2C%20editorial%20aesthetic&width=800&height=600&seq=cat-07&orientation=landscape&nocache=true",
  },
  {
    name: "Underwear/Underpants",
    url: "https://kaspreadsheet.com/search-918/name/Underwear-Underpants.html",
    image:
      "https://readdy.ai/api/search-image?query=Neatly%20folded%20white%20cotton%20underwear%20briefs%20stacked%20on%20a%20soft%20light%20gray%20background%20with%20gentle%20natural%20lighting%20and%20soft%20shadows%2C%20tasteful%20minimalist%20product%20photography%2C%20clean%20editorial%20aesthetic&width=800&height=600&seq=cat-08&orientation=landscape&nocache=true",
  },
  {
    name: "Jersey",
    url: "https://kaspreadsheet.com/search-919/name/Jersey.html",
    image:
      "https://readdy.ai/api/search-image?query=A%20bold%20red%20and%20white%20striped%20sports%20jersey%20displayed%20on%20a%20soft%20cream%20background%20with%20bright%20natural%20lighting%20and%20a%20subtle%20shadow%2C%20minimalist%20sportswear%20product%20photography%2C%20editorial%20aesthetic&width=800&height=600&seq=cat-09&orientation=landscape&nocache=true",
  },
  {
    name: "Accessories",
    url: "https://kaspreadsheet.com/search-920/name/Accessories.html",
    image:
      "https://readdy.ai/api/search-image?query=A%20minimal%20arrangement%20of%20a%20gold%20watch%2C%20sunglasses%20and%20a%20leather%20bracelet%20on%20a%20warm%20caramel%20background%20with%20soft%20natural%20lighting%20and%20gentle%20shadows%2C%20luxury%20accessories%20flat%20lay%20product%20photography%2C%20editorial%20aesthetic&width=800&height=600&seq=cat-10&orientation=landscape&nocache=true",
  },
  {
    name: "Bags",
    url: "https://kaspreadsheet.com/search-921/name/Bags.html",
    image:
      "https://readdy.ai/api/search-image?query=A%20tan%20leather%20crossbody%20bag%20displayed%20on%20a%20soft%20off-white%20background%20with%20warm%20natural%20lighting%20and%20a%20subtle%20soft%20shadow%2C%20minimalist%20handbag%20product%20photography%2C%20editorial%20aesthetic&width=800&height=600&seq=cat-11&orientation=landscape&nocache=true",
  },
  {
    name: "Belts",
    url: "https://kaspreadsheet.com/search-922/name/Belts.html",
    image:
      "https://readdy.ai/api/search-image?query=A%20dark%20brown%20leather%20belt%20coiled%20elegantly%20on%20a%20warm%20sand%20background%20with%20soft%20natural%20lighting%20and%20gentle%20shadows%2C%20minimalist%20accessory%20product%20photography%2C%20editorial%20aesthetic&width=800&height=600&seq=cat-12&orientation=landscape&nocache=true",
  },
  {
    name: "Perfumes",
    url: "https://kaspreadsheet.com/search-923/name/Perfumes.html",
    image:
      "https://readdy.ai/api/search-image?query=An%20amber%20glass%20perfume%20bottle%20with%20a%20gold%20cap%20on%20a%20soft%20cream%20background%20with%20warm%20natural%20lighting%20and%20a%20gentle%20shadow%2C%20minimalist%20luxury%20fragrance%20product%20photography%2C%20editorial%20aesthetic&width=800&height=600&seq=cat-13&orientation=landscape&nocache=true",
  },
  {
    name: "Other Stuff",
    url: "https://kaspreadsheet.com/search-924/name/Other-Stuff.html",
    image:
      "https://readdy.ai/api/search-image?query=A%20flat%20lay%20of%20assorted%20fashion%20lifestyle%20items%20including%20sunglasses%2C%20a%20watch%2C%20a%20cap%20and%20small%20leather%20goods%20arranged%20on%20a%20warm%20beige%20background%20with%20soft%20natural%20lighting%20and%20gentle%20shadows%2C%20minimalist%20product%20photography%2C%20editorial%20aesthetic&width=800&height=600&seq=cat-14&orientation=landscape&nocache=true",
  },
];